import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServiceProvidersService {
  api = environment.api;

  constructor( private http: HttpClient ) { }

  listServiceProviders(filters = "") {
    return this.http.get(this.api+`/prestador${filters}`);
  }

  getServiceProvider(id) {
    return this.http.get(this.api+`/prestador/${id}`);
  }

  addServiceProvider(raw) {
    return this.http.post(this.api+`/prestador`, raw);
  }

  editServiceProvider(raw) {
    return this.http.put(this.api+`/prestador`, raw);
  }
}
